export function handlePrint(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('a[print-pdf]');
	} else {
		var $cont = $(selector + ' a[print-pdf]');
	}

	$cont.each(function (idx) {
		let $a = $(this);
		$a.on('click', function (event) {
			event.preventDefault()
			printPDF($a.attr('href'))
		});
	});
}

function printPDF(url) {
	var iframe = window._printIframe;

	showK1Loader();

	if (!window._printIframe) {
		iframe = window._printIframe = document.createElement('iframe');
		document.body.appendChild(iframe);

		iframe.style.display = 'none';
		iframe.onload = function() {
			setTimeout(function() {
				hideK1Loader();
				iframe.focus();
				iframe.contentWindow.print();
			}, 1000);
		};
	}

	iframe.src = url;
}

window.printPDF = printPDF;
